import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12755d78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-nav" }
const _hoisted_2 = { class: "nav flex-column" }
const _hoisted_3 = { class: "d-flex" }

import { useMenu } from '@/model/components/menu/sideMenu'
import { useStore } from '@/store'

// 状態

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  inheritAttrs: false,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SideMenu',
  setup(__props) {

const store = useStore()
const { isSelected, MENU_LIST } = useMenu(store)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MENU_LIST), (data) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "nav-item",
          key: data.name
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["mxa-nav-menu-border", { 'mxa-nav-menu-border-active': _unref(isSelected)(data.name) }]),
              "data-test": "active_line"
            }, null, 2),
            _createVNode(_component_router_link, {
              to: data.routerName,
              class: _normalizeClass(["mxa-nav-menu-link", { 'mxa-nav-menu-link-active': _unref(isSelected)(data.name) }]),
              "data-test": "link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(data.resourcekey)), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})